import { Box } from '@mui/material'
import NodeBox from './common/NodeBox'
import Network from '@assets/flowchart/Network.svg'
import NodeSelect from './common/NodeSelect'
import NodeInput from './common/NodeInput'
import NodeSelectMany from './common/NodeSelectMany'
import NodeCheckBox from './common/NodeCheckBox'
import { useNodeData } from './common/useNodeData'

const NetworkNode = ({ id, data }: { id: string; data: any }) => {
  const patch = useNodeData(id)
  const manyOptions = [
    { id: '1', label: 'ראשון' },
    { id: '2', label: 'שני' },
    { id: '3', label: 'שלישי' },
    { id: '4', label: 'רביעי' },
    { id: '5', label: 'חמישי' },
    { id: '6', label: 'שישי' },
    { id: '7', label: 'שבת' },
  ]
  const firstOptions = [
    { id: '1', label: 'קליטות בחודש' },
    { id: '2', label: 'Rssi' },
    { id: '3', label: 'SNR' },
    { id: '4', label: 'Missing Telegrams' },
    { id: '5', label: 'ימים ברציפות ללא קליטה' },
  ]
  const secondOptions = [
    { id: '1', label: 'מעל' },
    { id: '2', label: 'מתחת' },
    { id: '3', label: 'שווה ל-' },
  ]
  const thirdOptions = [
    { id: '1', label: '%' },
    { id: '2', label: 'ימים' },
    { id: '3', label: 'dBm' },
    { id: '4', label: 'dB' },
  ]
  return (
    <NodeBox title="מאפיין תקשורת" icon={Network} nodeId={id}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <NodeSelect
          placeholder="מאפיין"
          options={thirdOptions}
          value={data?.unitSelectedId ?? null}
          onChangeValue={v => patch({ unitSelectedId: v })}
        />
        <NodeInput
          value={data?.thresholdValue ?? ''}
          onChange={v => patch({ thresholdValue: v })}
        />
        <NodeSelect
          placeholder="מאפיין"
          options={secondOptions}
          value={data?.operatorSelectedId ?? null}
          onChangeValue={v => patch({ operatorSelectedId: v })}
        />
        <NodeSelect
          placeholder="מאפיין"
          options={firstOptions}
          value={data?.metricSelectedId ?? null}
          onChangeValue={v => patch({ metricSelectedId: v })}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <NodeSelectMany
          options={manyOptions}
          option2SelectedId={data?.option2SelectedId ?? []}
          setOption2SelectedId={v => patch({ option2SelectedId: v })}
        />
        <NodeCheckBox
          text="התעלמות מימים"
          checked={data?.ignoreDaysChecked ?? false}
          onChange={e => patch({ ignoreDaysChecked: e.target.checked })}
        />
      </Box>
    </NodeBox>
  )
}

export default NetworkNode
